import React, { useEffect, useRef } from "react";
import "./rings.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import imgLeft1 from "./images/layerLeft1.webp";
import imgLeft2 from "./images/layerLeft2.webp";
import imgRight1 from "./images/layerRight1.webp";
import imgRight2 from "./images/layerRight2.webp";
import earringImg from "./images/videoProduct.mp4";

export default function Rings() {
  gsap.registerPlugin(ScrollTrigger);

  let col1Ref = useRef(null);
  let col2Ref = useRef(null);
  let col3Ref = useRef(null);
  let col4Ref = useRef(null);
  let titleRef = useRef(null);

  return (
    <div className="rings-main">
      <div className="component-header" ref={(el) => (titleRef = el)}>
        <p>PIERŚCIONKI</p>
      </div>
      <div className="component-images">
        <div className="component-column column-left">
          <div className="left-content">
            <div className="left-image-1" ref={(el) => (col2Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia_Mica_Stanga_Pozitia4"
                }
                alt=""
              />
            </div>
            <div className="left-image-2" ref={(el) => (col1Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia_Mare_Stanga_Pozitia4"
                }
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="component-column column-middle">
          <div className="middle-content">
            <div className="middle-image"></div>
            <a href="https://www.teilor.pl/pierscionek-z-zoltego-18-karatowego-zlota-z-2-66-karatowymi-diamentami-123967.html">
              <video
                className="middle-video"
                playsinline="true"
                autoplay="true"
                loop="true"
                muted="true"
              >
                <source
                  src="https://cdn.media.amplience.net/v/teilor/211198_YELLOW_VID/mp4_720p"
                  type="video/mp4"
                />
              </video>
            </a>
          </div>
        </div>
        <div
          className="component-column column-right"
          ref={(el) => (col3Ref = el)}
        >
          <div className="right-content">
            <div className="right-image-1" ref={(el) => (col3Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia_Mare_Dreapta_Pozitia4"
                }
                alt=""
              />
            </div>
            <div className="right-image-2" ref={(el) => (col4Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia_Mica_Dreapta_Pozitia4"
                }
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="component-content">
        <div className="component-content-title">
          <p>zachwycająca </p>
        </div>
        <div className="component-content-text">
          <p>
            {" "}
            Owoc kunsztu artystów, przepojony nietuzinkową osobowością. Taką,
            która potrafi ukazać się jedynie w brylantach. Jakie to wrażenie
            wiedzieć, że możesz je mieć na swoich palcach?
          </p>
        </div>
      </div>
    </div>
  );
}
